import React from 'react';
import { PERM_MOD_SETTINGS_MEMBERS, USER_OPERATIONS } from '../constants';
import { PortalConfigContext } from '../context';
import { useAppSelector } from './useStore';
import { useUserAccess } from './useUserAccess';

export const useUserCanInvite = () => {
  const portalConfig = React.useContext(PortalConfigContext);
  const isClient = useAppSelector(state => state.user.isClient);
  const isInviteConfigDisabled = Boolean(
    isClient && portalConfig.features.clientInvitesDisabled,
  );
  const isUserCanInvite =
    !isInviteConfigDisabled &&
    useUserAccess(PERM_MOD_SETTINGS_MEMBERS, USER_OPERATIONS.Invite);

  return { isUserCanInvite, isInviteConfigDisabled };
};
